export enum AddToDocumentMenuOption {
  JustText = 'JustText',
  WithSpeakers = 'WithSpeakers',
  WithTimestamps = 'WithTimestamps',
  WithSpeakersAndTimestamps ='WithSpeakersAndTimestamps'
}

export const TranscribingActionTypes = {
  SetEditingIndexAction: 'TRANSCRIBING_SET_EDITING_INDEX',
  SetFocusedIndexAction: 'TRANSCRIBING_SET_FOCUSED_INDEX',
  SetHighlightedIndexAction: 'TRANSCRIBING_SET_HIGHLIGHTING_INDEX',
  SetSourceFileAction: 'TRANSCRIBING_SET_SOURCE_FILE',
  SetTranscriptionDataAction: 'TRANSCRIBING_SET_TRANSCRIPTION_DATA',
  SetTranscriptionManager: 'TRANSCRIBING_SET_TRANSCRIPTION_MANAGER',
  SetAudioPlayingFlag: 'TRANSCRIBING_SET_AUDIO_PLAYING_FLAG',
  RevertStateAction: 'TRANSCRIBING_REVERT_STATE',
  SetTeachingUIClosedFlag: 'TRANSCRIBING_TEACHING_UI_CLOSED_FLAG',
  SetShowStartOverConfirmDialog: 'TRANSCRIBING_SET_SHOW_START_OVER_CONFIRMED_DIALOG',
  SetTranscriptionEntryPoints: 'TRANSCRIBING_SET_ENTRY_POINTS',
  SetAddToDocumentInProgressStatus: 'TRANSCRIBING_SET_ADD_TO_DOCUMENT_IN_PROGRESS_STATUS'
};